import * as React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

export const ContentEditsCreateGraphic = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} inheritViewBox={true}>
      <svg
        {...props}
        viewBox="0 0 260 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5054_1946)">
          <rect width="260" height="120" fill="#F5F7F7" />
          <g filter="url(#filter0_dd_5054_1946)">
            <rect
              x="42.8506"
              y="20.8992"
              width="180"
              height="112.101"
              rx="5.4"
              fill="#DFE3E3"
            />
            <g clipPath="url(#clip1_5054_1946)">
              <rect
                x="40.1504"
                y="18"
                width="180"
                height="112.101"
                rx="5.4"
                fill="white"
              />
              <path
                d="M40.1504 23.4C40.1504 20.4177 42.5681 18 45.5504 18H214.75C217.733 18 220.15 20.4177 220.15 23.4V30.6H40.1504V23.4Z"
                fill="#EFF1F1"
              />
              <circle cx="47.5758" cy="24.525" r="2.025" fill="#C9CDCD" />
              <circle cx="54.3258" cy="24.525" r="2.025" fill="#C9CDCD" />
              <circle cx="61.0758" cy="24.525" r="2.025" fill="#C9CDCD" />
              <rect
                x="50.9504"
                y="43.2"
                width="75.6"
                height="46.8"
                rx="2.7"
                fill="#EFF1F1"
              />
              <rect
                x="85.1506"
                y="49.5"
                width="7.2"
                height="9"
                rx="1.8"
                fill="#C9CDCD"
              />
              <rect
                x="79.7502"
                y="57.6"
                width="18"
                height="23.4"
                rx="1.8"
                fill="#C9CDCD"
              />
              <rect
                x="130.6"
                y="54.45"
                width="70.2"
                height="24.3"
                rx="1.8"
                fill="#EAF0FF"
              />
              <rect
                x="131.163"
                y="55.0125"
                width="69.075"
                height="23.175"
                stroke="#2962FF"
                strokeWidth="1.125"
              />
              <rect
                x="128.8"
                y="52.65"
                width="3.6"
                height="3.6"
                fill="white"
                stroke="#2962FF"
                strokeWidth="0.9"
              />
              <rect
                x="199.001"
                y="52.65"
                width="3.6"
                height="3.6"
                fill="white"
                stroke="#2962FF"
                strokeWidth="0.9"
              />
              <rect
                x="128.8"
                y="76.95"
                width="3.6"
                height="3.6"
                fill="white"
                stroke="#2962FF"
                strokeWidth="0.9"
              />
              <rect
                x="199.001"
                y="76.95"
                width="3.6"
                height="3.6"
                fill="white"
                stroke="#2962FF"
                strokeWidth="0.9"
              />
              <rect
                x="136.45"
                y="44.1"
                width="41.4"
                height="5.4"
                rx="2.7"
                fill="#C9CDCD"
              />
              <rect
                x="136.45"
                y="60.3"
                width="58.5"
                height="4.5"
                rx="2.25"
                fill="#E0E4E4"
              />
              <rect
                x="136.45"
                y="67.5"
                width="46.8"
                height="4.5"
                rx="2.25"
                fill="#E0E4E4"
              />
              <rect
                x="50.9504"
                y="99"
                width="75.6"
                height="4.5"
                rx="2.25"
                fill="#E0E4E4"
              />
              <rect
                x="135.551"
                y="84.6"
                width="45"
                height="9.9"
                rx="1.8"
                fill="#E0E4E4"
              />
              <path
                d="M190.019 84.1127L201.178 94.8226L202.389 95.9847H196.845L198.797 99.9623L199.096 100.573L198.484 100.868L195.874 102.128L195.266 102.421L194.973 101.813L192.944 97.6058L190.016 100.389L188.876 101.472V83.017L190.019 84.1127Z"
                fill="#161616"
                stroke="white"
                strokeWidth="1.35"
              />
            </g>
          </g>
        </g>
        <defs>
          <filter
            id="filter0_dd_5054_1946"
            x="28.1504"
            y="10"
            width="206.7"
            height="139"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_5054_1946"
            />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="6" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
            />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_5054_1946"
              result="effect2_dropShadow_5054_1946"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect2_dropShadow_5054_1946"
              result="shape"
            />
          </filter>
          <clipPath id="clip0_5054_1946">
            <rect width="260" height="120" fill="white" />
          </clipPath>
          <clipPath id="clip1_5054_1946">
            <rect
              x="40.1504"
              y="18"
              width="180"
              height="112.101"
              rx="5.4"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};
